var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-overlay fade",class:{ show: _vm.shown }},[_c('div',{staticClass:"overlay"}),_c('i',{staticClass:"fad fa-spinner fa-spin fa-3x"}),(_vm.text)?_c('span',{staticStyle:{"color":"blue"}},[_vm._v(_vm._s(_vm.text))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }